exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".services h1 {\n  margin-bottom: 60px;\n}\n.services .box-service {\n  height: 268px;\n  margin-bottom: 90px;\n  float: left;\n}\n.services .box-service img {\n  max-width: 150px;\n}\n.block-about.services .btn {\n  color: #881a1e;\n  background-color: #f6f1eb;\n}\n.block-about.services .btn:hover {\n  background-color: #881a1e;\n  color: #ffffff;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/services/services.component.less
// module id = ../../../../../src/app/services/services.component.less
// module chunks = main